import { lazy, Suspense } from "react";
import { SEO } from "@/components/SEO";
import ArqNavigation from "@/components/arqera/ArqNavigation";
import ArqHero from "@/components/arqera/ArqHero";
import ArqProblem from "@/components/arqera/ArqProblem";
import ArqServices from "@/components/arqera/ArqServices";
import ArqEngagementStory from "@/components/arqera/ArqEngagementStory";
import ArqFrontDoorOffer from "@/components/arqera/ArqFrontDoorOffer";
import ArqHowItWorks from "@/components/arqera/ArqHowItWorks";
import ArqProofBar from "@/components/arqera/ArqProofBar";
import ArqEngagementShapes from "@/components/arqera/ArqEngagementShapes";
import ArqAbout from "@/components/arqera/ArqAbout";
import ArqFAQ from "@/components/arqera/ArqFAQ";
import ArqBooking from "@/components/arqera/ArqBooking";
import ArqBookingModal from "@/components/arqera/ArqBookingModal";
import ArqFooter from "@/components/arqera/ArqFooter";
import CookieConsent from "@/components/CookieConsent";
import SkipToContent from "@/components/SkipToContent";

const ChatWidget = lazy(() => import("@/components/ChatWidget"));

export default function Index() {
  return (
    <div id="top" className="bg-arq-bg text-arq-text font-body">
      <SEO
        title="ArqeraAI | AI Feature Security Reviews for Regulated Teams"
        description="ArqeraAI helps software and regulated teams assess, remediate, and validate AI-enabled features before they expose customer data, break compliance, or stall enterprise deals."
        ogTitle="ArqeraAI | Ship AI Features Safely"
        ogDescription="AI Feature Security Reviews for teams launching chatbots, copilots, RAG search, AI agents, and AI workflows. Find, fix, and validate risks before customer or enterprise exposure."
        canonical="https://arqeraai.com/"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "ArqeraAI",
          url: "https://www.arqeraai.com",
          description: "ArqeraAI helps software and regulated teams find, fix, and validate AI feature risks before they expose customer data, break compliance, or stall enterprise deals.",
          serviceType: ["AI Security Engineering", "Application Security", "Agentic AI Security & Operational Controls", "Privacy Engineering & Consent Governance", "Remediation & Continuous Assurance"],
        }}
      />
      <SkipToContent />
      <ArqNavigation />
      <main id="main-content" tabIndex={-1} className="focus:outline-none">
        <ArqHero />
        <ArqFrontDoorOffer />
        <ArqProblem />
        <ArqEngagementStory />
        <ArqServices />
        <ArqHowItWorks />
        <ArqProofBar />
        <ArqEngagementShapes />
        <ArqAbout />
        <ArqFAQ />
        <ArqBooking />
      </main>
      <ArqFooter />
      <Suspense fallback={null}>
        <ChatWidget />
      </Suspense>
      <CookieConsent />
      <ArqBookingModal />
    </div>
  );
}
